import { Link } from "@tanstack/react-router";

export interface IndustryItem {
  idx: string;
  name: string;
  /** When omitted, row renders as plain text (no link, no chevron). */
  to?: string;
  tag?: string;
}

export function IndustryList({ items, compact = false }: { items: IndustryItem[]; compact?: boolean }) {
  if (compact) return (
    <ul className="m-0 grid list-none grid-cols-1 gap-x-6 p-0 sm:grid-cols-2">
      {items.map((item) => (
        <li key={item.to ?? item.name} className="border-t border-line py-3 text-[16px] font-light text-bleu">
          {item.to ? <Link to={item.to} className="block whitespace-nowrap">{item.name}</Link> : item.name}
        </li>
      ))}
    </ul>
  );
  return (
    <ul className="m-0 list-none p-0">
      {items.map((i) => {
        const rowStyle = {
          gridTemplateColumns: "1fr auto",
          padding: "26px 0",
          borderTop: "1px solid rgba(0,47,167,0.12)",
          color: "#002FA7",
        } as const;
        const inner = (
          <>
            <div className="flex items-baseline gap-6">
              <span
                className="mono"
                style={{
                  fontSize: 11,
                  color: "rgba(0,47,167,0.45)",
                  letterSpacing: "0.14em",
                }}
              >
                {i.idx}
              </span>
              <span
                style={{
                  fontFamily: '"IBM Plex Sans", "IBM Plex Sans Fallback", sans-serif',
                  fontWeight: 300,
                  fontSize: "clamp(22px, 2.4vw, 32px)",
                  letterSpacing: "-0.01em",
                }}
              >
                {i.name}
              </span>
            </div>
            <span
              className="mono"
              style={{
                fontSize: 11,
                letterSpacing: "0.16em",
                textTransform: "uppercase",
                color: "rgba(0,47,167,0.45)",
              }}
            >
              {i.to ? `${i.name} →` : i.name}
            </span>
          </>
        );
        return (
          <li key={`${i.idx}-${i.name}`}>
            {i.to ? (
              <Link to={i.to} className="group grid items-center" style={rowStyle}>
                {inner}
              </Link>
            ) : (
              <div className="grid items-center" style={rowStyle}>
                {inner}
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
}
